import React from 'react';
import styled from 'styled-components';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { ButtonProps } from '@mui/material/Button';
import EditRoundedIcon from '@mui/icons-material/EditRounded';

import AddButton from '@ui-parts/AddButton';
import EditButton from '@ui-elements/EditButton';

import { PALETTE } from '~/assets/styles/base';

const Wrapper = styled(Box)`
  width: 100%;
  background: ${PALETTE.white};
  border: 1px solid ${PALETTE.border.frame};
  opacity: 1;
  hr {
    opacity: 0.5;
    border-width: 1px;
    margin-top: 1px;
    margin-bottom: 1px;
  }
`;

const StyledBox = styled(Box)`
  padding: 4px 10px;
  display: flex;
  align-items: center;
  min-height: 58px;
  min-width: 364px; // 年齢が増えた時に性別が改行しないように
`;

const ConditionBoxLabel = styled(Box)`
  min-width: 90px;
  text-align: center;
  font-size: 13px;
`;

const ConditionBoxContent = styled(Box)`
  padding: 8px 0 8px 23px;
  width: 100%;
`;

const FlexBox = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const EditButtonContainer = styled.div`
  min-width: 66px;
  width: 66px;
`;

type Props = {
  conditionLabel: string;
  name: string;
  handleClickAddBtn?: ButtonProps['onClick'];
  selectedChoices?: Array<string | number>;
  editable?: boolean;
  handleClickEditBtn?: ButtonProps['onClick'];
};

const ConditionBox: React.FC<Props & ButtonProps> = ({
  conditionLabel,
  handleClickAddBtn,
  selectedChoices = [],
  name,
  editable = false,
  handleClickEditBtn,
}): JSX.Element => (
  <Wrapper>
    <StyledBox data-testid={`uiParts-ConditionBox-${name}`}>
      <ConditionBoxLabel data-testid={`uiParts-ConditionBox-lbl-${name}`}>
        <Typography
          variant="title4"
          component="span"
          color="text.main"
          dangerouslySetInnerHTML={{
            __html: conditionLabel,
          }}
        />
      </ConditionBoxLabel>
      <Divider orientation="vertical" variant="middle" flexItem />
      <ConditionBoxContent data-testid={`uiParts-ConditionBox-cnt-${name}`}>
        {!selectedChoices || selectedChoices.length === 0 ? (
          <Box textAlign="center">
            <AddButton handleClick={handleClickAddBtn} name={name} />
          </Box>
        ) : (
          <FlexBox>
            <div>
              <Typography variant="body2" component="span" color="text.main">
                {selectedChoices.join('、')}
              </Typography>
            </div>
            {selectedChoices && selectedChoices.length > 0 && editable && (
              <EditButtonContainer>
                <EditButton name={name} handleClick={handleClickEditBtn} sx={{ marginLeft: 26 }}>
                  <EditRoundedIcon />
                </EditButton>
              </EditButtonContainer>
            )}
          </FlexBox>
        )}
      </ConditionBoxContent>
    </StyledBox>
  </Wrapper>
);

export default ConditionBox;
